import { TrackingEvent } from '@marketplace-web/observability/event-tracker-data'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { Screen } from 'constants/tracking/screens'

type ClickEventArgs = {
  target: ClickableElement
  screen?: string | null
  targetDetails?: string | null
  path?: string | null
  env?: string | null
}

type ClickEventExtra = {
  target: ClickableElement
  screen?: string
  target_details?: string
  path?: string | null
  env?: string | null
}

export const clickEvent = (args: ClickEventArgs): TrackingEvent => {
  const { target, screen, targetDetails, env, path } = args
  const extra: ClickEventExtra = { target }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  if (env) extra.env = env

  if (path) extra.path = path

  return {
    event: 'user.click',
    extra,
  }
}

type DonationsClickEventArgs = {
  target: ClickableElement
  screen?: Screen | null
  targetDetails?: string | number
}

type DonationsClickEventExtra = {
  target: string
  screen?: string
  target_details?: string | number
}

export const donationsClickEvent = (args: DonationsClickEventArgs): TrackingEvent => {
  const { target, screen, targetDetails } = args

  const extra: DonationsClickEventExtra = {
    target,
  }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  return {
    event: 'user.click_donations',
    extra,
  }
}

type InboxSupportFeedbackEventsBaseArgs = {
  threadId: string
  helpCenterSessionId: string
}

type InboxSupportFeedbackClosedEventsArgs = InboxSupportFeedbackEventsBaseArgs & {
  rating?: number
}

export const chatbotFeedbackClosed = (args: InboxSupportFeedbackClosedEventsArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
    rating: args.rating,
  }

  return {
    event: 'automated_support_feedback.chatbot_feedback_closed',
    extra,
  }
}

export const autoreplyFeedbackClosed = (args: InboxSupportFeedbackClosedEventsArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
    rating: args.rating,
  }

  return {
    event: 'automated_support_feedback.auto_reply_feedback_closed',
    extra,
  }
}

export const chatbotFeedbackV1Viewed = (args: InboxSupportFeedbackEventsBaseArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'automated_support_feedback.chatbot_feedback_v1_viewed',
    extra,
  }
}

export const autoreplyFeedbackV1Viewed = (args: InboxSupportFeedbackEventsBaseArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'automated_support_feedback.auto_reply_feedback_v1_viewed',
    extra,
  }
}

type ReferralsOpenLinkEventArgs = {
  referrerId: number
}

type ReferralsOpenLinkEventExtra = {
  referrer_id: number
}

export const referralsOpenLinkEvent = (args: ReferralsOpenLinkEventArgs): TrackingEvent => {
  const { referrerId } = args

  const extra: ReferralsOpenLinkEventExtra = {
    referrer_id: referrerId,
  }

  return {
    event: 'sharing.referrals.open_link',
    extra,
  }
}
